<!-- <div  matTooltip="This section is applicable for rotating assets only." class="greasing-widget-container"> -->
<div class="greasing-widget-container">
  <div class="widget-header">
    <div class="title">Machine Greasing Status</div>
    <div class="action">
     
      <button class="greasing_btn" (click)="updateGreasingService()">
        Update
      </button>
    </div>
  </div>

  <div class="info-grid" *ngIf="!serviceLoader">

    <div class="grid-row">
      <div class="label status-label">
        <span *ngIf="!isOutForService" class="text-success">Asset in service</span>
        <span *ngIf="isOutForService" class="text-danger">Asset out for service</span>
      </div>

      <div class="value">
        <div *ngIf="userRoll !== 'USER'" class="toggle-container">
          <input
            type="checkbox"
            id="toggle"
            class="toggle-checkbox"
            (change)="onOFTToggleChange($event)"
            [checked]="isOutForService"
          />
          <label for="toggle" class="toggle-label"></label>
        </div>
      </div>
    </div>

    <div class="grid-row">
      <div class="label">Last Greasing</div>
      <div class="value">{{ this.serviceData.last_greasing_date || '--' }}</div>
    </div>

    <div class="grid-row">
      <div class="label">Sugg. Re-greasing After (Hrs)</div>
      <div class="value">{{ this.serviceData.total_hrs_till_now || '--' }}</div>
    </div>

    <div class="grid-row">
      <div class="label">Act Running Hrs since Last Greasing</div>
      <div class="value">{{ this.serviceData.act_total_hrs_till_now || '--' }}</div>
    </div>

    <div class="grid-row">
      <div class="label">Sugg. Re-greasing Date</div>
      <div class="value">{{ this.serviceData.act_nxt_greasing_date || '--' }}</div>
    </div>
  </div>

  <div *ngIf="meterData.client_id === '595'" class="warning-box">
    This section is applicable for rotating assets only
  </div>

  <div class="info-grid" *ngIf="serviceLoader">
    <div class="grid-row" *ngFor="let i of [1,2,3,4,5]">
      <div class="label"><div class="skeleton skeleton-text w_70"></div></div>
      <div class="value"><div class="skeleton skeleton-text w_40"></div></div>
    </div>
  </div>
</div>

<app-meter-service-modal
  *ngIf="showOFSModal"
  [type]="'ofs_modal'"
  [toggleValue]="outOfServiceChange"
  [subsystem_id]="meterData.subsystem_id"
  [service_id]="serviceData.service_id"
  (saveOFSModalData)="saveOFSModalData($event)"
  (closeOFSModal)="closeOFSModal($event)"
>
</app-meter-service-modal>

<app-meter-service-modal
  *ngIf="showGreasingModal"
  [type]="'greasing_modal'"
  [toggleValue]="outOfServiceChange"
  [subsystem_id]="meterData.subsystem_id"
  (saveGreasingModalData)="saveGreasingService($event)"
  (closeGreasingModal)="closeGreasingService($event)"
>
</app-meter-service-modal>
